import axiosInstance from './axiosInstance';

/**
 * Fetches all chatbots for the current user
 * @returns {Promise<Array>} Array of chatbot objects
 */
export const getAllChatbots = async () => {
  try {
    const response = await axiosInstance.get('/chatbot/all');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createChatbot = async (name, description, prompt, url) => {
  try {
    const response = await axiosInstance.post('/chatbot/create', {
      name,
      description,
      prompt,
      url
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}; 

export const deleteChatbot = async (chatbotId) => {
  try {
    const response = await axiosInstance.delete(`/chatbot/${chatbotId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateChatbotPicture = async (botId, formData) => {
  try {
    const response = await axiosInstance.put(`/chatbot/update-profile-picture/${botId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateChatbot = async (botId, data) => {
  try {
    const response = await axiosInstance.put(`/chatbot/update/${botId}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const uploadDocument = async (formData) => {
  try {
    const response = await axiosInstance.post('/document/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteDocument = async (documentId) => {
  try {
    const response = await axiosInstance.delete(`/chatbot/document/${documentId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};